module.exports = __webpack_public_path__ + "img/kataster_o.3613486d.png";